import {
  MapPermissionModel,
  MapPermissionModelEnum as P,
  MapCollaborationModel,
  MapCollaborationModelEnum as C,
  internalError,
} from "@cartographerio/types";
import { raise } from "@cartographerio/util";

export function generatedMapPermissionModel(sourceId: string): MapPermissionModel {
  switch (sourceId) {
    case "StdActivityDiary":
      return P.Workspace;
    case "StdInvasiveSpeciesSighting":
      return P.Workspace;
    case "StormPhosphates":
      return P.Public;
    case "ces":
      return P.Workspace;
    case "placemarkerStudyArea":
      return P.Workspace;
    case "FbaWindermere":
      return P.Public;
    case "FbaWindermereSite":
      return P.Public;
    case "mrsMorph":
      return P.Public;
    case "mrsMorphCache":
      return P.RoleBased;
    case "mrsMorph5":
      return P.RoleBased;
    case "mrsMorph10":
      return P.Public;
    case "mrsRta":
      return P.RoleBased;
    case "mrsRiverCondition":
      return P.Workspace;
    case "mrsMorphEstuaries":
      return P.Public;
    case "mrsMorphPro":
      return P.Workspace;
    case "mrsMorphProCache":
      return P.RoleBased;
    case "mrsMorph5Pro":
      return P.Workspace;
    case "mrsMorph10Pro":
      return P.Workspace;
    case "mrsRtaPro":
      return P.Workspace;
    case "mrsRiverConditionPro":
      return P.Workspace;
    case "mrsMorphEstuariesPro":
      return P.Workspace;
    case "MrsMudSpotter":
      return P.Public;
    case "neLakeNaturalness":
      return P.Public;
    case "neRiverNaturalness":
      return P.Public;
    case "neLakeRestorationPriorities":
      return P.Public;
    case "neRiverRestorationPriorities":
      return P.Public;
    case "neRiverRestorationPriorityAreas":
      return P.Public;
    case "neChalkRivers":
      return P.Public;
    case "NwcSeedbank":
      return P.Public;
    case "riverflySite":
      return P.Public;
    case "riverflyHistory":
      return P.Public;
    case "riverflyStatus":
      return P.Public;
    case "urbanRiverflyHistory":
      return P.Public;
    case "urbanRiverflyStatus":
      return P.Public;
    case "extendedRiverflyHistory":
      return P.Public;
    case "extendedRiverflyStatus":
      return P.Public;
    case "thames21BadgedGroupEvent":
      return P.Public;
    case "thames21GreenWallModule":
      return P.RoleBased;
    case "thames21Inns":
      return P.Public;
    case "thames21Litter":
      return P.Public;
    case "thames21RapidAppraisal":
      return P.RoleBased;
    case "Thames21SlowFlow":
      return P.Public;
    case "thames21Vegetation":
      return P.RoleBased;
    case "thames21WaterQuality":
      return P.Public;
    case "thames21ThamesWaterQuality":
      return P.Public;
    case "StSmartRivers":
      return P.Public;
    case "StSmartRiversSite":
      return P.Public;
    case "urs":
      return P.Public;
    case "placemarkerRiverStretch":
      return P.Workspace;
    case "wrtFords":
      return P.RoleBased;
    case "wrtWestcountryCsi":
      return P.Public;
    case "wrtWestcountryCsiDetail":
      return P.Public;
    case "wrtUpstreamThinking":
      return P.RoleBased;
    default:
      return raise(internalError(`No generated map collaboration model for ${sourceId}`));
  }
}

export function generatedMapCollaborationModel(sourceId: string): MapCollaborationModel {
  switch (sourceId) {
    case "StdActivityDiary":
      return C.SingleWorkspace;
    case "StdInvasiveSpeciesSighting":
      return C.SingleWorkspace;
    case "StormPhosphates":
      return C.SingleWorkspace;
    case "ces":
      return C.SingleWorkspace;
    case "placemarkerStudyArea":
      return C.SingleWorkspace;
    case "FbaWindermere":
      return C.SingleWorkspace;
    case "FbaWindermereSite":
      return C.SingleWorkspace;
    case "mrsMorph":
      return C.CrossWorkspace;
    case "mrsMorphCache":
      return C.SingleWorkspace;
    case "mrsMorph5":
      return C.CrossWorkspace;
    case "mrsMorph10":
      return C.CrossWorkspace;
    case "mrsRta":
      return C.SingleWorkspace;
    case "mrsRiverCondition":
      return C.SingleWorkspace;
    case "mrsMorphEstuaries":
      return C.CrossWorkspace;
    case "mrsMorphPro":
      return C.SingleWorkspace;
    case "mrsMorphProCache":
      return C.SingleWorkspace;
    case "mrsMorph5Pro":
      return C.SingleWorkspace;
    case "mrsMorph10Pro":
      return C.SingleWorkspace;
    case "mrsRtaPro":
      return C.SingleWorkspace;
    case "mrsRiverConditionPro":
      return C.SingleWorkspace;
    case "mrsMorphEstuariesPro":
      return C.SingleWorkspace;
    case "MrsMudSpotter":
      return C.CrossWorkspace;
    case "neLakeNaturalness":
      return C.CrossWorkspace;
    case "neRiverNaturalness":
      return C.CrossWorkspace;
    case "neLakeRestorationPriorities":
      return C.CrossWorkspace;
    case "neRiverRestorationPriorities":
      return C.CrossWorkspace;
    case "neRiverRestorationPriorityAreas":
      return C.CrossWorkspace;
    case "neChalkRivers":
      return C.CrossWorkspace;
    case "NwcSeedbank":
      return C.SingleWorkspace;
    case "riverflySite":
      return C.CrossWorkspace;
    case "riverflyHistory":
      return C.CrossWorkspace;
    case "riverflyStatus":
      return C.CrossWorkspace;
    case "urbanRiverflyHistory":
      return C.CrossWorkspace;
    case "urbanRiverflyStatus":
      return C.CrossWorkspace;
    case "extendedRiverflyHistory":
      return C.CrossWorkspace;
    case "extendedRiverflyStatus":
      return C.CrossWorkspace;
    case "thames21BadgedGroupEvent":
      return C.SingleWorkspace;
    case "thames21GreenWallModule":
      return C.SingleWorkspace;
    case "thames21Inns":
      return C.SingleWorkspace;
    case "thames21Litter":
      return C.SingleWorkspace;
    case "thames21RapidAppraisal":
      return C.SingleWorkspace;
    case "Thames21SlowFlow":
      return C.SingleWorkspace;
    case "thames21Vegetation":
      return C.SingleWorkspace;
    case "thames21WaterQuality":
      return C.SingleWorkspace;
    case "thames21ThamesWaterQuality":
      return C.SingleWorkspace;
    case "StSmartRivers":
      return C.SingleWorkspace;
    case "StSmartRiversSite":
      return C.SingleWorkspace;
    case "urs":
      return C.CrossWorkspace;
    case "placemarkerRiverStretch":
      return C.SingleWorkspace;
    case "wrtFords":
      return C.SingleWorkspace;
    case "wrtWestcountryCsi":
      return C.SingleWorkspace;
    case "wrtWestcountryCsiDetail":
      return C.SingleWorkspace;
    case "wrtUpstreamThinking":
      return C.SingleWorkspace;
    default:
      return raise(internalError(`No generated map permission model for ${sourceId}`));
  }
}
